import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';

import filter from "../filter.png"

import { useMediaQuery } from 'react-responsive';

const options = [
    {
        name: 'Enable both scrolling & backdrop',
        scroll: true,
        backdrop: true,
    }
];

function MobSidebar({ name, ...props }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const toggleShow = () => setShow((s) => !s);

    const isMobile = useMediaQuery({ query: '(max-width: 992px)' })

    return (
        <>
            <Button onClick={toggleShow} className={`filter_btn  me-2 ${isMobile ? "d-block" : "d-none"}`}>
                <div className='d-flex jc-center ai-center'>
                    <img src={filter} alt="image" className='img-fluid me-2 filter_icon' />
                    Filters
                </div>
            </Button>
            <Offcanvas show={show} onHide={handleClose} scroll={true} backdrop="static">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filters</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body>
                    {props.children}
                </Offcanvas.Body>

            </Offcanvas>

            {/* <Button variant="primary" onClick={toggleShow}>
                Toggle static offcanvas
            </Button>

            <Offcanvas show={show} onHide={handleClose} backdrop="static" backdropClassName="offcanvas-backdrop">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Offcanvas</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    I will not close if you click outside of me.
                </Offcanvas.Body>
            </Offcanvas> */}

        </>
    );
}

function Example() {
    return (
        <>
            {options.map((props, idx) => (
                <MobSidebar key={idx} {...props} />
            ))}
        </>
    );
}

export default MobSidebar